import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type InvitationMessageJSON = z.infer<typeof InvitationMessageSchema.InvitationMessageJSONZ>;
export type InvitationMessageParams = z.infer<typeof InvitationMessageSchema.InvitationMessageZ>;

export default class InvitationMessageSchema {
  public static readonly InvitationMessageJSONZ = z.string();
  public static readonly InvitationMessageZ = z.string().min(1, "Invitation message cannot be empty.");

  public static validate(values: unknown): InvitationMessageParams {
    return parseOrThrow(InvitationMessageSchema.InvitationMessageZ, values, {
      logError: true,
      schemaName: "InvitationMessageSchema",
      operation: "validate",
      payloadSample: values,
    });
  }

  public static validateJSON(values: unknown): InvitationMessageJSON {
    return parseOrThrow(InvitationMessageSchema.InvitationMessageJSONZ, values, {
      logError: true,
      schemaName: "InvitationMessageSchema",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValid(values: unknown): values is InvitationMessageParams {
    try {
      InvitationMessageSchema.validate(values);
      return true;
    } catch {
      return false;
    }
  }

  public static isValidJSON(values: unknown): values is InvitationMessageParams {
    try {
      InvitationMessageSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): InvitationMessageParams {
    const parsed = parseOrThrow(InvitationMessageSchema.InvitationMessageJSONZ, data, {
      logError: true,
      schemaName: "InvitationMessageSchema",
      operation: "deserialize",
      payloadSample: data,
    });
    return parsed;
  }

  public static serialize(data: InvitationMessageParams): InvitationMessageJSON {
    if (isNullOrUndefined(data)) return data;
    const parsed = InvitationMessageSchema.validate(data);
    return parsed;
  }
}
